import { Form, Formik } from "formik";
import Close from "../../../../../../images/Close.svg";
import { Title } from "../../../../../../stories/Title/Title";
import { LabelProps, rfqFormData } from "../../../../../../utils/types";
import { quotationItemValidation } from "../../../../../../utils/validationSchema";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import InputHoc from "../../../../../common/Input/Index";
import {
  CustomModal,
  getModifiedScrollHeight,
  handleFormEvent,
  toIsoDate,
  toStandardDate,
} from "../../../../../../utils/UtilFunctions";
import { Button } from "../../../../../../stories/Button/Button";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../../utils/Enum.keys";
import { AppContext as LocalStateContext } from "./statesProvider/materialContext";
import {
  AtsMrfMstForRfqsEdge,
  GetMrfsForRFQsResult,
  rfqPendingItemType,
} from "../queries/types";
import {
  AutocompleteInput,
  EMPTY_STRING,
  FETCH_MORE_DATA,
} from "../../../../../../utils/constants";
import Modal from "react-modal";
import { TextField } from "@mui/material";
import { Label } from "../../../../../../stories/Label/Label";
import MultiSelectSupplier from "../../material/MultiSelectSupplier";
import { rfqStatesType } from "./statesProvider/materialReducer";
import DataFetch from "../../../../../../images/OpenIcon.svg";
import { useLazyQuery } from "@apollo/client";
import {
  AtsMrfMstEdge,
  AtsMrfMstOrderField,
  GetMrfsVars,
  MrfQueryType,
} from "../../material/queries/types";
import { GetMrfsForRFQs } from "../queries/queries";
import { rfqForm } from "../../../../../../utils/formTypes";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";

import useUrlParams from "../../../../../../customHooks/useUrlParams";
import { AppContext } from "../../../../../../context/context";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import ApprovedList, { formDates } from "../../material/ApprovedList";
import { itemsType } from "./Add";
import ItemsModal from "./components/ItemsModal";
import { ViewItemModalStyles } from "../../../../../../styles/CustomModalStyles";
import Assign from "../../material/Assign";
import { Operation } from "../../../../../../utils/Enum.types";
import useLabels from "../../../../../../customHooks/useLabels";
import { LdgrQueryType } from "../../../masters/supplier/queries/types";

interface itemDataProp {
  items: itemsType[];
  setItems: React.Dispatch<React.SetStateAction<itemsType[]>>;
  selectedId: number;
  addItemOpretion: Operation;
  setAddItemOpretion: React.Dispatch<React.SetStateAction<Operation>>;
}

interface Props {
  setModal: (value: React.SetStateAction<boolean>) => void;
  itemsDataState: itemDataProp;
}

const AddQuotationItemModal = ({ setModal, itemsDataState }: Props) => {
  const initialRqForm: rfqForm = {
    lastDateForSubmission: "",
    rfqPreparedBy: "",
    rfqAuthorisedBy: "",
    tc: "",
    payTerms: "",
    remarks: "",
  };
  const initialValues: rfqFormData = {
    mrfNo: "",
    mrfDate: "",
    udfDesc: "",
    uom: "",
    presentStck: "",
    approxRate: "",
    approxQty: "",
    approxTaxable: "",
    tax: "",
    taxedValue: "",
    netValue: "",
    terms: "",
    paymentTerms: "",
    remark: "",
    subsidary: null,
    mrfId: 0,
  };

  const { state } = useContext(AppContext);
  const { state: localState, dispatch } = useContext(LocalStateContext);
 
  const { customer_id } = useUrlParams();
  const termsRef = useRef<HTMLTextAreaElement | null>(null);

  const [searchMrf, setSearchMrf] = useState("");
  const [mrfListModal, setMrfListModal] = useState(false);

  const [rqForm, setRqForm] = useState<rfqForm>(initialRqForm);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [mrfs, setMrfs] = useState<AtsMrfMstForRfqsEdge[]>([]);

  const { items, setItems, selectedId, addItemOpretion, setAddItemOpretion } =
    itemsDataState;
  const [formData, setFormData] = useState<rfqFormData>(initialValues);
  const autoCompleteRefs = document.getElementsByClassName(AutocompleteInput);
  const isAutoMounted = autoCompleteRefs && autoCompleteRefs.length === 5;

  const [edit, setEdit] = useState(false);
  const [itemlistModal, setItemListModal] = useState(false);
  const [supplierListModal, setSupplierListModal] = useState(false);

  const [selectedItemsId, setSelectedItemId] = useState<Set<number>>(new Set());

  const { data: todaysDateData, serverDate } = useServerDateandTime();

  const [dates, setDates] = useState<formDates>({
    startDate: "",
    endDate: "",
  });

  const [GetMrfRfqs, { data: mrfData, loading, fetchMore }] = useLazyQuery<
    GetMrfsForRFQsResult,
    GetMrfsVars
  >(GetMrfsForRFQs);

  const handleScroll = (e: React.UIEvent<HTMLUListElement, UIEvent>) => {
    const target = e.target as HTMLDivElement;
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const clientHeight = target.clientHeight;
    if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
      if (hasNextPage && !loading) {
        fetchMore({
          variables: {
            first: FETCH_MORE_DATA,
            after: endCursor,
          },
          updateQuery: (prevResult, { fetchMoreResult }) => {
            if (!fetchMoreResult) return prevResult;

            const newEdges = fetchMoreResult.GetMrfs.edges;
            const pageInfo = fetchMoreResult.GetMrfs.pageInfo;
            setEndCursor(pageInfo.endCursor);
            setHasNextPage(pageInfo.hasNextPage);

            const duplicateCheck = prevResult.GetMrfs.edges.filter(
              ({ node: { id } }) =>
                newEdges.findIndex(
                  ({ node: { id: newId } }) => newId === id
                ) !== -1
            );

            if (duplicateCheck.length > 0) return prevResult;

            return {
              GetMrfs: {
                edges: [...mrfs, ...newEdges],
                pageInfo,
                totalCount: mrfData ? mrfData.GetMrfs.totalCount! : 0,
              },
            };
          },
        });
      }
    }
  };

  const handleMrfSelect = (
    newValue: AtsMrfMstForRfqsEdge | AtsMrfMstEdge | null
  ) => {
    if (newValue) {
      const mrfEdge = newValue as AtsMrfMstForRfqsEdge;
      dispatch({
        type: rfqStatesType.MRF,
        payload: {
          mrf: mrfEdge,
        },
      });
      setFormData({
        ...formData,
        mrfDate: mrfEdge.node.mrfDate,
        mrfNo: mrfEdge.node.mrfNo,
        mrfId: mrfEdge.node.id,
        subsidary: {
          label: mrfEdge.node.subsidiary.name,
          value: mrfEdge.node.subsidiary.id,
        },
      });
    } else {
      dispatch({
        type: rfqStatesType.MRF,
        payload: {
          mrf: null,
        },
      });
      setFormData(initialValues);
    }
  };

  const handleItemSelect = (
    newValue: rfqPendingItemType | AtsMrfMstEdge | null
  ) => {
    if (newValue) {
      const mrfEdge = newValue as rfqPendingItemType;
      dispatch({
        type: rfqStatesType.SET_ITEM_ID,
        payload: {
          itm: mrfEdge,
        },
      });
      const taxedValue = ((mrfEdge.tax / 100) * mrfEdge.taxable).toString();
      setFormData({
        ...formData,
        approxQty: mrfEdge.acceptQty.toString(),
        approxRate: mrfEdge.approxRate.toString(),
        approxTaxable: mrfEdge.taxable.toString(),
        uom: mrfEdge.uom,
        udfDesc: mrfEdge.udfItemDesc,
        presentStck: mrfEdge.presentStk.toString(),
        tax: mrfEdge.tax.toString(),
        taxedValue,
        netValue: mrfEdge.taxable + taxedValue,
      });
    } else {
      dispatch({
        type: rfqStatesType.MRF,
        payload: {
          mrf: null,
        },
      });
      setFormData(initialValues);
    }
  };

  const handleClear = () => {
    setFormData({ ...initialValues, mrfDate: "", mrfNo: "", mrfId: 0 });
    setRqForm(initialRqForm);
    setAddItemOpretion(Operation.NONE);
    dispatch({
      type: rfqStatesType.MRF,
      payload: {
        mrf: null,
      },
    });
    dispatch({
      type: rfqStatesType.SET_ITEM_ID,
      payload: {
        itm: null,
      },
    });
    dispatch({
      type: rfqStatesType.SUPPLIERS,
      payload: {
        selectedSuppliers: [],
      },
    });
  };

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
  };

  const handleItem = () => {
    if (edit) {
      if (
        localState.itm &&
        localState.mrf &&
        localState.selectedSuppliers.length
      ) {
        const filteredItems = items.filter(
          (itm, index) => index !== selectedId
        );

        const foundDuplicate = filteredItems.find(
          (itm, index) =>
            localState.mrf &&
            itm.mrf.node.id === localState.mrf.node.id &&
            localState.itm &&
            localState.itm.id === itm.item.id
        );
        if (foundDuplicate) {
          alert("Found duplicate item");
        } else {
          setEdit(false);
          const tempSet = selectedItemsId;
          tempSet.delete(localState.itm.id);
          setSelectedItemId(tempSet);
          const updatedItems = items.map((itm, index) => {
            if (index === selectedId) {
              return {
                ...(formData as rfqFormData),
                suppliers: localState.selectedSuppliers,
                item: localState.itm,
                mrf: localState.mrf,
              } as itemsType;
            } else {
              return itm;
            }
          });
          setItems(updatedItems);
          handleClear();
        }
      }
    } else {
      if (localState.itm && localState.mrf) {
        const tempSet = selectedItemsId;
        tempSet.add(localState.itm.id);
        setSelectedItemId(tempSet);
        setItems([
          {
            ...(formData as rfqFormData),
            suppliers: localState.selectedSuppliers,
            item: localState.itm,
            mrf: localState.mrf,
          },
          ...items,
        ]);
        handleClear();
        if (isAutoMounted) {
          (autoCompleteRefs[2] as HTMLInputElement).focus();
        }
      }
    }
  };

  useEffect(() => {
    if (mrfData && !loading) {
      const newData = mrfData.GetMrfs.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = mrfs.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setMrfs(updatedNewData);
      } else {
        setMrfs(newData);
      }
      setEndCursor(mrfData.GetMrfs.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [mrfData, loading]);

  const options = useMemo(() => {
    const mrfOptions = edit
      ? mrfs
      : mrfs.reduce((acc, mrf) => {
          var flag = false;

          mrf.node.rfqPendingItems.map((itm) => {
            if (selectedItemsId.has(itm.id) === false) {
              flag = true;
            }
          });

          if (flag) {
            acc = [mrf, ...acc];
          }

          return acc;
        }, [] as AtsMrfMstForRfqsEdge[]);

    const foundMrf = mrfs.find(
      (m) => localState.mrf && m.node.id === localState.mrf.node.id
    );
    const itemOptions: rfqPendingItemType[] = foundMrf
      ? foundMrf.node.rfqPendingItems.filter(
          (item) => selectedItemsId.has(item.id) === false || edit
        )
      : [];

    return {
      mrfOptions,
      itemOptions,
    };
  }, [
    mrfs,
    mrfs.length,
    localState.mrf,
    selectedItemsId,
    edit,
    loading,
    mrfData,
    selectedId,
  ]);

  useEffect(() => {
    if (customer_id && state.ActiveFinYr)
      GetMrfRfqs({
        variables: {
          after: null,
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          first: 6,
          name: searchMrf,
          start_date: toIsoDate(dates.startDate),
          end_date: toIsoDate(dates.endDate),
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsMrfMstOrderField.MRF_NO,
          },
          queryType: MrfQueryType.APPROVED_MRFS,
         
        },
      });
  }, [GetMrfRfqs, customer_id, state.ActiveFinYr, searchMrf, dates]);

  useEffect(() => {
    if (todaysDateData && serverDate) {
      const getMonth = new Date(serverDate).getMonth();
      const getYear = new Date(serverDate).getFullYear();

      const firstDay = new Date(getYear, getMonth, 1); // First day of the month
      const lastDay = new Date(getYear, getMonth + 1, 0);

      setDates({
        endDate: lastDay.toString(),
        startDate: firstDay.toString(),
      });
    }
  }, [todaysDateData, serverDate]);

  useEffect(() => {
    const handleEditItem = (id: number) => {
      const foundItem = items.find((itm, index) => index === id);

      if (foundItem) {
        const { suppliers, item, mrf, ...rest } = foundItem;
        setFormData(rest);
      }
    };

    if (addItemOpretion === Operation.UPDATE) handleEditItem(selectedId);
  }, [selectedId, addItemOpretion]);
  const { itemLabel } = useLabels();
  return (
    <>
      <div className="material-item-add">
        <div className="material-item-add__title">
          <Title>Add {itemLabel}</Title>
          <img src={Close} alt="" onClick={() => setModal(false)} />
        </div>
        <Formik
          initialValues={formData}
          validationSchema={quotationItemValidation}
          onSubmit={handleItem}
          enableReinitialize
          validateOnChange
        >
          {(meta) => {
            return (
              <Form className="material-item-add__form">
                <div className="material-item-add__form--details row g-0">
                  <div className="material-item-add__form--details--left col">
                    {quotationItemsForm.left.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.inputName === "mrfNo") {
                          return (
                            <>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <div className="d-flex">
                                  <FormAutocomplete
                                    className={formClasses.inputRoot}
                                    options={options.mrfOptions}
                                    // onKeyDown={(e) => {
                                    //   if (e.key === Keys.ENTER) {
                                    //     if (isAutoMounted && localState.mrf) {
                                    //       (autoCompleteRefs[3] as HTMLInputElement).focus();
                                    //     }
                                    //   }
                                    // }}
                                    getOptionLabel={(option) => {
                                      return (option as AtsMrfMstForRfqsEdge)
                                        .node.mrfNo;
                                    }}
                                    value={localState.mrf}
                                    openOnFocus
                                    forcePopupIcon
                                    slotProps={{
                                      listbox: {
                                        onScroll: handleScroll,
                                      },
                                    }}
                                    isOptionEqualToValue={(option) =>
                                      localState.mrf
                                        ? (option as AtsMrfMstForRfqsEdge).node
                                            .id === localState.mrf.node.id
                                        : false
                                    }
                                    onChange={(e, newValue) => {
                                      handleMrfSelect(
                                        newValue as AtsMrfMstForRfqsEdge
                                      );
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        fullWidth
                                        required
                                        autoFocus
                                        onChange={(e) =>
                                          setSearchMrf(e.target.value)
                                        }
                                        className={formClasses.formControlRoot}
                                      />
                                    )}
                                  />
                                  <img
                                    src={DataFetch}
                                    alt=""
                                    onClick={() =>
                                      setMrfListModal(!mrfListModal)
                                    }
                                    className="data-fetch-icon"
                                  />
                                </div>
                              </div>
                            </>
                          );
                        } else if (field.inputName === "udfDesc") {
                          return (
                            <>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <div className="d-flex">
                                  <FormAutocomplete
                                    className={formClasses.inputRoot}
                                    options={options.itemOptions}
                                    // onKeyDown={(e) => {
                                    //   if (e.key === Keys.ENTER) {
                                    //     if (isAutoMounted && localState.itm) {
                                    //       (autoCompleteRefs[4] as HTMLInputElement).focus();
                                    //     }
                                    //   }
                                    // }}
                                    getOptionLabel={(option) =>
                                      (option as rfqPendingItemType).item.code
                                        .length
                                        ? `${
                                            (option as rfqPendingItemType).item
                                              .desc
                                          } ${
                                            (option as rfqPendingItemType).item
                                              .code
                                          }`
                                        : `${
                                            (option as rfqPendingItemType).item
                                              .desc
                                          }`
                                    }
                                    value={localState.itm}
                                    openOnFocus
                                    forcePopupIcon
                                    onChange={(e, newValue) => {
                                      handleItemSelect(
                                        newValue as rfqPendingItemType
                                      );
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        fullWidth
                                        required
                                        onChange={(e) =>
                                          setSearchMrf(e.target.value)
                                        }
                                        className={formClasses.formControlRoot}
                                      />
                                    )}
                                  />
                                  <img
                                    src={DataFetch}
                                    alt=""
                                    onClick={() =>
                                      setItemListModal(!itemlistModal)
                                    }
                                    className="data-fetch-icon"
                                  />
                                </div>
                              </div>
                            </>
                          );
                        } else {
                          return (
                            <>
                              <React.Fragment key={key}>
                                <InputHoc
                                  LabelName={field.labelName}
                                  values={
                                    field.inputName === "mrfDate"
                                      ? formData.mrfDate
                                        ? toStandardDate(formData.mrfDate)
                                        : EMPTY_STRING
                                      : field.inputName === "subsidary"
                                      ? formData.subsidary
                                        ? formData.subsidary.label
                                        : EMPTY_STRING
                                      : formData[field.inputName]
                                  }
                                  name={field.inputName}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e);
                                  }}
                                  type={field.dataType}
                                  required={field.required}
                                  autoFocus={field.autoFocus}
                                  onKeyDown={handleFormEvent}
                                  disabled={field.disabled}
                                />
                                {meta.touched[field.inputName] &&
                                meta.errors[field.inputName] ? (
                                  <div className="label-grid">
                                    <span />
                                    <span className="nodata">
                                      {meta.errors[field.inputName]}
                                    </span>
                                  </div>
                                ) : null}
                              </React.Fragment>
                            </>
                          );
                        }
                      }
                    )}
                  </div>
                  <div className="material-item-add__form--details--right col">
                    {quotationItemsForm.right.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.inputName === "rfq_vendor") {
                          return (
                            <>
                              <React.Fragment key={key}>
                                <div className="label-grid">
                                  <Label>{field.labelName}</Label>
                                  <div className="d-flex">
                                    <MultiSelectSupplier
                                      onChange={(newValue) => {
                                        if (newValue) {
                                          dispatch({
                                            type: rfqStatesType.SUPPLIERS,
                                            payload: {
                                              selectedSuppliers: newValue,
                                            },
                                          });
                                        }
                                      }}
                                      autoCompleteValue={
                                        localState.selectedSuppliers
                                      }
                                      handleClear={() => {}}
                                      onKeyDown={(e) => {
                                        if (e.key === Keys.ENTER) {
                                          if (termsRef.current) {
                                            termsRef.current.focus();
                                          }
                                        }
                                      }}
                                      input={{
                                        itemID: 0,
                                        query_type: LdgrQueryType.ALL,
                                        tableLevel: undefined,
                                      }}
                                    />
                                    <img
                                      src={DataFetch}
                                      alt=""
                                      onClick={() =>
                                        setSupplierListModal(!supplierListModal)
                                      }
                                      className="data-fetch-icon"
                                    />
                                  </div>
                                </div>
                              </React.Fragment>
                            </>
                          );
                        }
                        return (
                          <>
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e);
                                }}
                                type={field.dataType}
                                required={field.required}
                                autoFocus={field.autoFocus}
                                onKeyDown={handleFormEvent}
                                disabled={field.disabled}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
                <div className="row g-0">
                  <div className="col">
                    {/* <Button mode="save" type="submit">
               &nbsp;({itemsCount})
             </Button> */}
                    <Button mode="save" type="submit" />

                    <Button mode="clear" onClick={handleClear} type="button" />
                    <Button
                      mode="cancel"
                      onClick={() => {
                        handleClear();
                        setModal(false);
                      }}
                      type="button"
                    />
                  </div>
                  {/* <div className="col flex-end">
             <Button
               mode="save-continue"
               onClick={() => {
                 setAddOneItem(true);
                 handleSubmit();
               }}
               type="button"
             />
           </div> */}
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>

      <Modal
        ariaHideApp={false}
        shouldCloseOnOverlayClick={true}
        isOpen={mrfListModal}
        onRequestClose={() => {
          setMrfListModal(!mrfListModal);
        }}
        style={ViewItemModalStyles}
      >
        <ApprovedList
          pageType={MrfQueryType.APPROVED_MRFS}
          isMrfselect
          onSelect={handleMrfSelect}
          setModalFlag={setMrfListModal}
          showFilter={false}
        />
      </Modal>

      <Modal
        ariaHideApp={false}
        shouldCloseOnOverlayClick={true}
        isOpen={itemlistModal}
        onRequestClose={() => {
          setItemListModal(!itemlistModal);
        }}
        style={ViewItemModalStyles}
      >
        <ItemsModal
          itemOptions={options.itemOptions}
          setModalFlag={setItemListModal}
          handleItemSelect={handleItemSelect}
        />
      </Modal>

      <CustomModal
        isOpen={supplierListModal}
        onRequestClose={() => setSupplierListModal(!supplierListModal)}
        contentComponent={
          <Assign
            setModalFlag={setSupplierListModal}
            value={localState.selectedSuppliers}
          />
        }
        style={ViewItemModalStyles}
      />
    </>
  );
};

export default AddQuotationItemModal;

export const quotationItemsForm = {
  left: [
    {
      labelName: "MRF No",
      inputName: "mrfNo",
      dataType: "text",
    },
    {
      labelName: "MRF Date",
      inputName: "mrfDate",
      dataType: "text",
      disabled: true,
    },
    {
      labelName: "Subsidary",
      inputName: "subsidary",
      dataType: "text",
      disabled: true,
    },
    {
      labelName: "Item Description",
      inputName: "udfDesc",
      dataType: "text",
    },
    {
      labelName: "Description Send for RFQ",
      inputName: "uom",
      dataType: "text",
      disabled: true,
    },
    {
      labelName: "UOM",
      inputName: "uom",
      dataType: "text",
      disabled: true,
    },
    {
      labelName: "Present Stock",
      inputName: "presentStck",
      dataType: "text",
      disabled: true,
    },
    {
      labelName: "Approx Rate",
      inputName: "approxRate",
      dataType: "text",
      disabled: true,
    },
    {
      labelName: "Accept Qty",
      inputName: "approxQty",
      dataType: "text",
      disabled: true,
    },
  ],

  right: [
    {
      labelName: "Approx Taxable Value",
      inputName: "approxTaxable",
      dataType: "text",
      disabled: true,
    },

    {
      labelName: "Tax",
      inputName: "tax",
      dataType: "text",
      disabled: true,
    },
    {
      labelName: "Taxes Value",
      inputName: "taxedValue",
      dataType: "text",
      disabled: true,
    },
    {
      labelName: "Approx Net Value",
      inputName: "netValue",
      dataType: "text",
      disabled: true,
    },
    {
      labelName: `RFQ Vendor`,
      inputName: "rfq_vendor",
      dataType: "text",
    },
    {
      labelName: "Terms",
      inputName: "terms",
      dataType: "text",
    },
    {
      labelName: "Payment Terms",
      inputName: "paymentTerms",
      dataType: "text",
    },
    {
      labelName: "Remark",
      inputName: "remark",
      dataType: "text",
    },
  ],
};
